import React, { Component } from "react";
import { Loader, Nav, PaginationClass } from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in";

import Declare from "../../components/anomaly/Declare";
import Statistics from "../../components/anomaly/Statistics";
import List from "../../components/anomaly/List";
import ShowOptionsNGRA from "../../components/general/ShowOptionsNGRA-v2";
import PrintClass from "../../components/general/Print";

import axiosConfig from "../../utils/axiosConfig";

import AuthContext from "../../context/AuthContext";
import filterStore from "../../stores/filterStore";

export default class Anomaly extends Component {
  constructor(props) {
    super(props);
    const saved = filterStore.getState().getPageState("anomaly");
    this.state = saved || {
      isLoad: false,
      // ShowOption state
      network: 0,
      group: 0,
      region: 0,
      agency: 0,
      user: 0,
      company: 0,
      year: 0,
      // Statistics state
      data: null,
      // List state
      activePage: 1,
      tabLength: 20,
      total: 0,
      dataList: [],
      order: null,
      // Modal state
      dataModal: {},
    };

    this.refPrintStatistics = React.createRef();
    this.refPrintList = React.createRef();
  }

  componentWillUnmount() {
    filterStore.getState().setPageState("anomaly", this.state);
  }

  static contextType = AuthContext;

  componentDidMount() {
    this.PaginationClass = new PaginationClass(
      "anomaly/count",
      "anomaly/pagination",
      this.state.tabLength
    );
  }

  // ShowOption data

  handleDataChange = (data) => {
    filterStore.getState().setPageFilters("anomaly", data);
    this.setState(
      {
        network: data.network,
        group: data.group,
        region: data.region,
        agency: data.agency,
        company: data.company,
        user: data.user,
        year: data.year,
      },
      () => {
        this.getAnomalyData();
        this.initSearch();
      }
    );
  };

  // Statistics data

  getAnomalyData() {
    this.setState({ isLoad: true }, () => {
      axiosConfig("anomaly/get-data", {
        data: this.getData(),
      }).then((res) => {
        if (res.data.success === true) {
          this.setState({ data: res.data.data, isLoad: false });
        } else {
          this.setState({ data: null, isLoad: false });
        }
      });
    });
  }

  // List data

  initSearch = () => {
    this.setState({ activePage: 1 }, () => {
      this.PaginationClass.init(axiosConfig, this.getData(), (result) => {
        if (result.success === true) {
          this.setState({ total: result.total }, () => {
            this.PaginationClass.get(axiosConfig, this.getData(), (result) => {
              this.setData(result);
            });
          });
        }
      });
    });
  };

  setData(result) {
    if (result.success === true) {
      this.setState({ dataList: result.tabData });
    } else {
      this.setState({ dataList: [] });
    }
  }

  getData() {
    return {
      network: this.state.network,
      group: this.state.group,
      region: this.state.region,
      agency: this.state.agency,
      user: this.state.user,
      company: this.state.company,
      year: this.state.year,
      orderName: this.state.order ? this.state.order.name : null,
      orderDesc: this.state.order ? this.state.order.desc : null,
    };
  }

  handlePageChange = (activePage) => {
    this.setState({ isLoad: true });
    this.PaginationClass.page(activePage, () =>
      this.setState({ activePage: activePage }, () => {
        this.PaginationClass.get(axiosConfig, this.getData(), (result) => {
          if (result.success === true) {
            this.setState({ isLoad: false }, () => {
              this.setData(result);
            });
          }
        });
      })
    );
  };

  handleSortClick = (order) => {
    this.setState({ order }, () => {
      this.initSearch();
    });
  };

  handleDeleteAnomaly = (id) => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("anomaly/delete-anomaly", {
        data: { id },
      }).then((res) => {
        if (res.data.success === true) {
          this.setState({ isLoad: false }, () => {
            this.getAnomalyData();
            this.initSearch();
          });
        } else {
          this.setState({ isLoad: false }, () => {
            alert("Une erreur est survenue");
          });
        }
      });
    });
  };

  handleUpdateAnomaly = (id, data) => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("anomaly/update-anomaly", {
        data: { id, data },
      }).then((res) => {
        if (res.data.success === true) {
          this.setState({ isLoad: false }, () => {
            this.getAnomalyData();
            this.initSearch();
          });
        } else {
          this.setState({ isLoad: false }, () => {
            alert("Une erreur est survenue");
          });
        }
      });
    });
  };

  handleAddResponse = (id, response) => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("anomaly/add-response", {
        data: { id, response },
      }).then((res) => {
        if (res.data.success === true) {
          this.setState({ isLoad: false }, () => {
            this.initSearch();
          });
        } else {
          this.setState({ isLoad: false }, () => {
            alert("Une erreur est survenue");
          });
        }
      });
    });
  };

  render() {
    return (
      <>
        <FadeIn>
          <Nav title="Anomalies" className="mb-10 mb-20-xl" />
          {!this.context.role || this.context.role === 0 ? null : (
            <Declare
              className="mb-10 mb-20-xl"
              onInsert={() => {
                this.getAnomalyData();
                this.initSearch();
              }}
            />
          )}
          <ShowOptionsNGRA
            isChange={true}
            className="mb-10 mb-20-xl"
            onDataChange={this.handleDataChange}
            initialFilters={filterStore.getState().getPageFilters("anomaly")}
            isYear={true}
            isCompany={true}
            isUser={true}
            visibilityRole={this.props.visibilityRole}
            visibilityType={this.props.visibilityType}
            preloadRole={this.props.preloadRole}
            preloadType={this.props.preloadType}
            limitUserType={this.props.limitUserType}
            limitUserRole={this.props.limitUserRole}
            isAll={true}
            isFake={true}
            notAllUsersType={true}
            userType={[1, 2, 3]}
          />
          {this.state.data ? (
            <FadeIn>
              <div ref={this.refPrintStatistics}>
                <Statistics
                  className="mb-10 mb-20-xl"
                  data={this.state.data}
                  isPrint={this.state.isPrint}
                  onLabelsLoaded={(isLoad) => this.setState({ isLoad })}
                />
              </div>
            </FadeIn>
          ) : null}
          {this.state.dataList ? (
            <FadeIn>
              <div ref={this.refPrintList}>
                <List
                  className="mb-10 mb-20-xl"
                  activePage={this.state.activePage}
                  tabLength={this.state.tabLength}
                  data={this.state.dataList}
                  total={this.state.total}
                  onPageChange={this.handlePageChange}
                  onSortClick={this.handleSortClick}
                  onDeleteAnomaly={this.handleDeleteAnomaly}
                  onUpdateAnomaly={this.handleUpdateAnomaly}
                  onAddResponse={this.handleAddResponse}
                  isPrint={this.state.isPrint}
                />
              </div>
            </FadeIn>
          ) : null}
        </FadeIn>
        <Loader show={this.state.isLoad} />
        <PrintClass
          refs={
            this.state.isPrint && this.state.isLoad
              ? [this.refPrintStatistics, this.refPrintList]
              : []
          }
          title={"Anomalies"}
          fileName={"Anomalies"}
          onPrint={(print) => this.setState({ isPrint: print, isLoad: print })}
          width={1000}
        />
      </>
    );
  }
}
